export default {
  APP_INITIALIZING_CHANGED: 'app_initializing_changed',
  USER_CHANGED: 'user_changed',
};
